import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Chioma A.",
      rating: 5,
      text: "The freshest à la carte dining experience in VI. Their soups are unmatched!"
    },
    {
      name: "Michael O.",
      rating: 5,
      text: "Best pastries on the island. Everything is made fresh daily."
    },
    {
      name: "Sarah K.",
      rating: 5,
      text: "Traditional dishes prepared with modern flair. Absolutely fantastic!"
    }
  ];

  return (
    <section className="relative py-16 bg-black text-white overflow-hidden">
      {/* Background Circles */}
      <div className="absolute top-[-50px] left-[-50px] w-64 h-64 bg-red-500 rounded-full opacity-20" />
      <div className="absolute bottom-[-100px] right-[-100px] w-96 h-96 bg-red-500 rounded-full opacity-10" />
      <div className="absolute top-1/2 right-[-50px] w-40 h-40 bg-red-500 rounded-full opacity-20" />
      <div className="absolute bottom-10 left-10 w-32 h-32 bg-red-500 rounded-full opacity-20" />

      <div className="container mx-auto px-4 relative z-10">
        <motion.h2 
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-3xl font-serif font-bold text-center mb-12"
        >
          Voices of Luxury
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div 
              key={index} 
              className="bg-gray-800 p-6 rounded-lg shadow-lg"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 400, damping: 17 }}
            >
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-red-500 fill-current" />
                ))}
              </div>
              <p className="text-gray-400 mb-4 font-light">{testimonial.text}</p>
              <p className="font-medium text-red-500">{testimonial.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
